import { ApiError } from './http.ts';

/**
 * The retry rule a query hook states instead of inheriting TanStack's default of three (performance rule
 * 12), passed as `retry`.
 *
 * - **A 4xx is never retried.** It is an answer: what was not found is not found again, a refusal is not
 *   lifted by asking twice, and retrying into a 429 is how a caller stays refused. Known gap 39 is the
 *   cost of the default — each 404 asked four times, the screen waiting seconds to say so.
 * - **Anything else is retried once.** A 5xx or a dropped connection may be passing; a heavy read that
 *   failed once is not made cheaper by three more attempts.
 *
 * It is every app's QueryClient default (#128, gap 39); a hook still states it, or another rule, where it matters.
 */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
}
